var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nature/sun"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.49997 2.38892V3.81114M14.5283 4.47171L13.5226 5.47738M16.6111 9.50001H15.1889M14.5283 14.5283L13.5226 13.5227M9.49997 15.1889V16.6111M5.47732 13.5227L4.47166 14.5283M3.81114 9.50009H2.38892M5.47729 5.47743L4.47163 4.47177M12.3444 9.50003C12.3444 11.071 11.0709 12.3445 9.49997 12.3445C7.92903 12.3445 6.65553 11.071 6.65553 9.50003C6.65553 7.92908 7.92903 6.65558 9.49997 6.65558C11.0709 6.65558 12.3444 7.92908 12.3444 9.50003Z",
    stroke: "#B5EBFF",
    strokeWidth: 1.06667,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.dc5edeac513e11c51d68840580c2f92e.svg";
export { ForwardRef as ReactComponent };